export const IBusiness = {
  id: 101,
  first_name: 'Reza',
  surname: 'Samiei',
  business_name: 'Testing Business',
  server_number: 0,
  business_type: 1,
  note: '',
  email: 'c1@rezasamiei.com',
  country_code: 'Un',
  currency_code: 'gbp',
  language_code: 'en',
  timezone: 'Europe/London',
  is_archive: false,
  created_at: '2024-01-09T07:28:04.904Z',
  updated_at: '2024-01-09T07:28:04.904Z',
  archived_at: null,
  partner_id: 0,
  server_id: 1,
  billing_address: {
    line1: 'line 1',
    line2: 'line 2',
    country: '',
    city: 'London',
    postcode: '123456',
  },
  contact_number: '1234567890',
  contact_number_code: '+44',
  description: 'Desc',
}
